import { SmsResponse } from 'src/modules/groupMessageEmail/models/smsResponse';
import { GroupMessageSmsStatusSearchFilter } from 'src/modules/groupMessageEmail/models/groupMessageSmsStatusSearchFilter';
import AxiosInstance from './axios/interceptor';
import { PagedResult } from '../models/pagedResult';
import { setPagingParams } from '../functions/createPagingParams';

const controller = 'Sms';

export const getSmsByBatchId = (pageIndex, pageSize, sortCol, sortDir, searchFilter: GroupMessageSmsStatusSearchFilter) => {
  const endpoint = `${controller}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}&smsBatchId=${searchFilter.smsBatchId}`;
  return AxiosInstance.get<PagedResult<SmsResponse>>(endpoint);
};
